import script from "./MTagList.vue?vue&type=script&setup=true&lang=js"
export * from "./MTagList.vue?vue&type=script&setup=true&lang=js"

import "./MTagList.vue?vue&type=style&index=0&id=b10c393a&lang=scss"

const __exports__ = script;

export default __exports__